import * as AccountResources from '../constants/accountResourceNames';
export function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
}
/**
 * @param {number} countryCode
 * @returns { defaultCountryId, accountResourceId }
 */
export function getInitialCountryCode(countryCode) {
    switch (countryCode) {
        case 'KG':
            return {
                defaultCountryId: 96,
                accountResourceId: AccountResources.KG,
            };
        case 'UZ':
            return {
                defaultCountryId: 192,
                accountResourceId: AccountResources.UZ,
            };
        default:
            return {
                defaultCountryId: 79,
                accountResourceId: AccountResources.KZ,
            };
    }
}



// WEBPACK FOOTER //
// ./src/shared/sharedFunctions.js